import { i18n } from "@/locale";

const {
    global: { t },
} = i18n;

export const apps = [
    {
        value: "2kog",
        label: t("notification.message.all"),
        key: "2kog",
        pinned: true,
    },
    // {
    //     value: "miipet",
    //     label: t("common.app.miipet"),
    //     key: "miipet",
    //     pinned: false,
    //     external: "https://mii.pet",
    // },
    // {
    //     value: "apibook",
    //     label: t("common.app.apibook"),
    //     key: "apibook",
    //     pinned: false,
    //     external: "https://api-book.com",
    // },
    {
        value: "fsf",
        label: t("common.app.fsf"),
        key: "fsf",
        pinned: false,
        external: "https://fsf.2kog.com",
    },
];
